import { render, staticRenderFns } from "./KnowledgeGraph.vue?vue&type=template&id=0fd0fbda&scoped=true"
import script from "./KnowledgeGraph.vue?vue&type=script&lang=js"
export * from "./KnowledgeGraph.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeGraph.vue?vue&type=style&index=0&id=0fd0fbda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0fbda",
  null
  
)

export default component.exports